import * as params from '../util/params'

import {TIPO_AMB_DEV} from '../util/constantes'

import * as util from '../util/util'

import * as texto from '../util/texto'

import base64 from 'react-native-base64'


export const MENSAGEM_ERRO_GENERICA = "Um erro ocorreu, tente novamente mais tarde.";


function getUrl(){
	
	return params.AMBIENTE ==TIPO_AMB_DEV?params.WS_URL_DEV+params.WS_API_DEV:params.WS_URL_PROD+params.WS_API_PROD;
}


function getToken(){
	
	return base64.encode(params.AMBIENTE ==TIPO_AMB_DEV?params.WS_USR_DEV+":"+params.WS_PWD_DEV:params.WS_USR_PROD+":"+params.WS_PWD_PROD);
}


function cabecalho_json(){
	
	return cabecalho("application/json")
}


function cabecalho(ContentType){

	if(texto.isBlanck(ContentType))
		ContentType = "application/json"
	
	let url = getUrl();
	        
    return {"Access-Control-Allow-Origin": url.split("/")[0]+"//"+url.split("/")[2],
				"Authorization": "Basic "+getToken(),
            		"Content-Type": ContentType}
}


export async function post(dominio, funcao, params, retornar_somente_dados=true){
	
	return enviar("POST", dominio, funcao, params, retornar_somente_dados);
}


export async function get(dominio, funcao, params, retornar_somente_dados=true){

	return enviar("GET", dominio, funcao, params, retornar_somente_dados);
}


export async function upload(dominio, funcao, params, imagem, retornar_somente_dados=true){

	if(params ==null)
		params = {}

	params['dominio'] = dominio;
	params['funcao'] = funcao;

	let url = getUrl();
	
    console.log('TENTATIVA DE CONEXAO POST (upload) url |'+url);

	let headers = {"Access-Control-Allow-Origin": url.split("/")[0]+"//"+url.split("/")[2],
		"Authorization": "Basic "+getToken()};

	//let headers = cabecalho("multipart/form-data; charset=utf-8; boundary="+Math.random().toString().substring(2));

    console.log('cabecalho: '+JSON.stringify(headers));

	const data = new FormData();
	
	for (const key of Object.keys(params))
		data.append(key, params[key]);
	
	console.log('params: '+JSON.stringify(params));
	
    data.append('imagem', imagem);

	console.log('params: '+JSON.stringify(data));
	
    try {
        
        const response = await fetch(url, {method: "POST", headers: headers, body: data});

        console.log('retorno: '+JSON.stringify(response));

        if (response===null || !response.ok)
            return null;
        
        const retorno = await response.json();
		
		//console.log('retorno: '+JSON.stringify(retorno));
		
		if(retornar_somente_dados){

			if(retorno== null || retorno.status<=0 || retorno.dados==null)
				return null;
	
			//if(Array.isArray(retorno.dados) && !util.temConteudo(retorno.dados))
			//	return null;
		
			return retorno.dados;
		}

        return retorno;
    }
    catch (e) {

        console.log("erro - consumir exception "+e); 
        
        return null;
    } 
}


async function enviar(metodo, dominio, funcao, params, retornar_somente_dados){

	if(params ==null)
		params = {}

	params['dominio'] = dominio;
	params['funcao'] = funcao;

	let url = getUrl();
	
    console.log('TENTATIVA DE CONEXAO '+metodo+' url |'+url+"|");

	let headers = cabecalho_json();

    console.log('cabecalho: '+JSON.stringify(headers));

	console.log('params: '+JSON.stringify(params));

    try {
        
        const response = metodo == 'GET'?
				await fetch(url+"?"+new URLSearchParams(params), {method: metodo, headers: headers}):
				await fetch(url, {method: metodo, headers: headers, body: JSON.stringify(params)});

        console.log('retorno: '+JSON.stringify(response));

        if (response===null || !response.ok)
            return null;
        
        const retorno = await response.json();
		
		console.log('retorno: '+JSON.stringify(retorno));
		
		if(retornar_somente_dados){

			if(retorno== null || retorno.status<=0 || retorno.dados==null)
				return null;
	
			//if(Array.isArray(retorno.dados) && !util.temConteudo(retorno.dados))
			//	return null;
		
			return retorno.dados;
		}

        return retorno;
    }
    catch (e) {

        console.log("erro - consumir exception "+e); 
        
        return null;
    } 
}
